// This file is auto-generated by scripts/generate-cms-overlay-catalog.ts.
import { upgradeOverlayClientRuntimeEntries } from './upgrade/client-runtime-entries';

export const cmsOverlayClientRuntimeEntries = [
  ...upgradeOverlayClientRuntimeEntries,
];
